import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'
import store from '@/store'
import { ReportAgendsServices } from '../../services/modules/report-agend.service'
import { APIReportAgend } from '../../models/api/report-agend.model'

@Module
export default class ReportAgendsStore extends VuexModule {
    reportAgends: object[] = []

    @Mutation
    updateAgends (news: object[]) {
        this.reportAgends = news
    }

    @Action
    getReportAgends (params: {userId: number; reportId: number}) {
        return new Promise((resolve) => {
            ReportAgendsServices.getAgendsByUser(params)
                .then(resp => {
                    store.commit('updateAgends', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createAgends (params: APIReportAgend) {
        return new Promise((resolve) => {
            ReportAgendsServices.createReportAgends(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editAgends (params: APIReportAgend) {
        return new Promise((resolve) => {
            ReportAgendsServices.editReportAgends(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteReporAgends (id: number) {
        return new Promise((resolve) => {
            ReportAgendsServices.deleteReportAgends(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
